module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-BoldItalic.woff2?d7b769523ff82fa5f0dde5533b3eefc1";